import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewMidSelected = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 30 30" {...props}>
    <path
      fill="#F4C874"
      fillOpacity={0.37}
      fillRule="evenodd"
      d="M15.572 5.303 20.873 0H0v20.874l5.303-5.303V5.303h10.268ZM14.428 24.697 9.127 30H30V9.126l-5.303 5.303v10.268H14.429Z"
      clipRule="evenodd"
    />
    <path fill="currentColor" fillRule="evenodd" d="M25.072 0 0 25.071V30h4.929L30 4.929V0h-4.928Z" clipRule="evenodd" />
  </svg>
);
